export default __webpack_public_path__ + "static/media/The Headless.a18ac649.png";